import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import { useLoadMoreLogic } from "~/components/LoadMoreSpinner/useLoadMoreLogic";
/**
 * This component calls loadMore function if it becomes visible to a user
 */ const LoadMoreSpinner = (param)=>{
    let { loadMore, isVisible, isLoading, topOffset = 64 } = param;
    useLoadMoreLogic({
        loadMore,
        isVisible,
        isLoading
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "relative",
        "data-testid": "LOAD_MORE_SPINNER",
        style: {
            top: topOffset
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex h-16 items-start justify-center",
            children: /*#__PURE__*/ _jsx(Spinner, {
                className: "size-7 text-teal-9"
            })
        }, 0)
    });
};
export default LoadMoreSpinner;
